import store from '@/state/store'

export default [
   {
      path: '/',
      name: 'home',
      meta: {
         authRequired: true,
      },
      component: () => import('./views/dashboards/default'),
   },

   {
      path: '/dashboard',
      name: 'dashboard',
      meta: {
         authRequired: true,
      },
      component: () => import('./views/dashboards/default'),
   },
   {
      path: '/login',
      name: 'login',
      component: () => import('./views/account/login'),
      meta: {
         beforeResolve(routeTo, routeFrom, next) {
            // If the user is already logged in
            if (store.getters['auth/loggedIn']) {
               // Redirect to the home page instead
               next({ name: 'default' })
            } else {
               // Continue to the login page
               next()
            }
         },
      },
   },

   {
      path: '/logout',
      name: 'logout',
      meta: {
         authRequired: true,
         beforeResolve(routeTo, routeFrom, next) {
            if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
               store.dispatch('auth/logOut')
            } else {
               store.dispatch('authfack/logout')
            }
            const authRequiredOnPreviousRoute = routeFrom.matched.some(
               (route) => route.push('/login')
            )
            // Navigate back to previous page, or home as a fallback
            next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
         },
      },
   },
   {
      path: '/404',
      name: '404',
      component: require('./views/utility/404').default,
   },
   // Redirect any unmatched routes to the 404 page. This may
   // require some server configuration to work in production:
   // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
   {
      path: '*',
      redirect: '404',
   },

   {
      path: '/specializations',
      name: 'specializations',
      meta: { authRequired: true },
      component: () => import('./views/specializations/specializations')
   },

   {
      path: '/clinics',
      name: 'clinics',
      meta: { authRequired: true },
      component: () => import('./views/clinics/clinics')
   },

   {
      path: '/patients',
      name: 'patients',
      meta: { authRequired: true },
      component: () => import('./views/patients/patients')
   },

   {
      path: '/patients/add',
      name: 'patients.add',
      meta: { authRequired: true },
      component: () => import('./views/patients/add-patient')
   },

   {
      path: '/patients/edit/:id',
      name: 'patients.edit',
      meta: { authRequired: true },
      component: () => import('./views/patients/edit-patient')
   },

   {
      path: '/patients/details/:id',
      name: 'patients.details',
      meta: { authRequired: true },
      component: () => import('./views/patients/patient-details')
   },

   {
      path: '/patients/records/:id',
      name: 'patients.records',
      meta: { authRequired: true },
      component: () => import('./views/patients/records')
   },

   {
      path: '/patients/bookings/:id',
      name: 'patients.bookings',
      meta: { authRequired: true },
      component: () => import('./views/patients/bookings')
   },
   {
      path: '/patients/members/:id',
      name: 'patients.members',
      meta: { authRequired: true },
      component: () => import('./views/patients/members')
   },

   {
      path: '/patients/members/details/:id',
      name: 'patients.members.details',
      meta: { authRequired: true },
      component: () => import('./views/patients/member-details')
   },
   {
      path: '/patients/members/bookings/:id',
      name: 'patients.members.bookings',
      meta: { authRequired: true },
      component: () => import('./views/patients/member-bookings')
   },
   {
      path: '/patients/members/records/:id',
      name: 'patients.members.records',
      meta: { authRequired: true },
      component: () => import('./views/patients/member-records')
   },
   {
      path: '/patients/wallet-logs/:id',
      name: 'patients.wallet.logs',
      meta: { authRequired: true },
      component: () => import('./views/patients/wallet-logs')
   },
   {
      path: '/patients/lab_bookings/:id',
      name: 'patients.lab_bookings',
      meta: { authRequired: true },
      component: () => import('./views/patients/lab_bookings')
   },
   {
      path: '/patients/member_lab_bookings/:id',
      name: 'patients.member_lab_bookings',
      meta: { authRequired: true },
      component: () => import('./views/patients/member_lab_bookings')
   },
   {
      path: "/doctors/pending",
      name: "doctors.pending",
      meta: { authRequired: true },
      component: () => import('./views/doctors/pending-doctors')
   },

   {
      path: "/doctors/pending/details/:id",
      name: "doctors.pending.details",
      meta: { authRequired: true },
      component: () => import('./views/doctors/pending-doctor-details')
   },

   {
      path: "/doctors/rejected",
      name: "doctors.rejected",
      meta: { authRequired: true },
      component: () => import('./views/doctors/rejected-doctors')
   },

   {
      path: '/doctors',
      name: 'doctors',
      meta: { authRequired: true },
      component: () => import('./views/doctors/doctors')
   },

   {
      path: '/doctors/add',
      name: 'doctors.add',
      meta: { authRequired: true },
      component: () => import('./views/doctors/add-doctor')
   },

   {
      path: '/doctors/edit/:id',
      name: 'doctors.edit',
      meta: { authRequired: true },
      component: () => import('./views/doctors/edit-doctor')
   },

   {
      path: '/doctors/details/:id',
      name: 'doctors.details',
      meta: { authRequired: true },
      component: () => import('./views/doctors/doctor-details')
   },

   {
      path: '/doctors/schedules/:id',
      name: 'doctors.schedules',
      meta: { authRequired: true },
      component: () => import('./views/doctors/schedules')
   },

   {
      path: '/doctors/upcoming-schedules/:id',
      name: 'doctors.upcoming',
      meta: { authRequired: true },
      component: () => import('./views/doctors/upcoming-schedules')
   },

   {
      path: '/doctors/bookings/:id',
      name: 'doctors.bookings',
      meta: { authRequired: true },
      component: () => import('./views/doctors/bookings')
   },
   {
      path: '/doctors/schedules/edit/:id',
      name: 'doctors.edit.schedules',
      meta: { authRequired: true },
      component: () => import('./views/doctors/edit-schedules-leave-new')
   },
   {
      path: '/doctors/schedules/changes/:id',
      name: 'doctors.schedule.changes',
      meta: { authRequired: true },
      component: () => import('./views/doctors/schedule-change')
   },

   {
      path: '/doctors/schedule-requests',
      name: 'doctors.schedule.requests',
      meta: { authRequired: true },
      component: () => import('./views/doctors/schedule-requests')
   },
   {
      path: '/doctors/schedule-requests/details/:id',
      name: 'doctors.schedule.requests.details',
      meta: { authRequired: true },
      component: () => import('./views/doctors/schedule-requests-details')
   },
   {
      path: '/doctor-payments/pending',
      name: 'payments.pending',
      meta: { authRequired: true },
      component: () => import('./views/doctor-payments/pending')
   },

   {
      path: '/doctor-payments/pending/details/:id',
      name: 'payments.pending.details',
      meta: { authRequired: true },
      component: () => import('./views/doctor-payments/pending-details')
   },

   {
      path: '/doctor-payments/completed',
      name: 'payments.completed',
      meta: { authRequired: true },
      component: () => import('./views/doctor-payments/completed')
   },

   {
      path: '/doctor-payments/completed/details/:id',
      name: 'payments.completed.details',
      meta: { authRequired: true },
      component: () => import('./views/doctor-payments/completed-details')
   },
   {
      path: '/doctors/symptom-questions/:id',
      name: 'doctors.symptom.questions',
      meta: { authRequired: true },
      component: () => import('./views/doctors/symptom-questions')
   },
   {
      path: '/doctors/symptom-subquestions/:id',
      name: 'doctors.symptom.subquestions',
      meta: { authRequired: true },
      component: () => import('./views/doctors/symptom-subquestions')
   },
   {
      path: '/doctors/tv/:id',
      name: 'doctors.tv',
      meta: { authRequired: true },
      component: () => import('./views/doctors/tv')
   },


   {
      path: '/consultations',
      name: 'consultations',
      meta: { authRequired: true },
      component: () => import('./views/consultations/consultations')
   },

   {
      path: '/consultations/add/:id?',
      name: 'consultations.add',
      meta: { authRequired: true },
      component: () => import('./views/consultations/add-consultation')
   },

   {
      path: '/consultations/details/:id',
      name: 'consultations.details',
      meta: { authRequired: true },
      component: () => import('./views/consultations/consultation-details')
   },

   {
      path: '/consultations/reschedule/:id/:doctor_id/:patient_id/:type/:clinic_id?',
      name: 'consultations.reschedule',
      meta: { authRequired: true },
      component: () => import('./views/consultations/reschedule')
   },

   {
      path: '/consultations/cancelled',
      name: 'consultations.cancelled',
      meta: { authRequired: true },
      component: () => import('./views/consultations/cancelled-consultations')
   },

   {
      path: "/pharmacy-orders",
      name: "pharmacy.orders",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/orders')
   },

   {
      path: "/pharmacy-orders/add",
      name: "pharmacy.orders.add",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/create-order')
   },

   {
      path: "/pharmacy-orders/reorder/:id/:pid",
      name: "pharmacy.orders.reorder",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/reorder')
   },

   {
      path: "/pharmacy-orders/details/:id",
      name: "pharmacy.orders.details",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/order-details')
   },

   {
      path: "/pharmacy-requests",
      name: "pharmacy.requests",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/requests')
   },

   {
      path: "/pharmacy-requests/details/:id",
      name: "pharmacy.requests.details",
      meta: { authRequired: true },
      component: () => import('./views/pharmacy/request-details')
   },

   {
      path: '/languages',
      name: 'languages',
      meta: { authRequired: true },
      component: () => import('./views/languages/languages')
   },

   {
      path: '/sliders',
      name: 'sliders',
      meta: { authRequired: true },
      component: () => import('./views/sliders/sliders')
   },

   {
      path: '/banners',
      name: 'banners',
      meta: { authRequired: true },
      component: () => import('./views/banners/banners')
   },

   {
      path: '/coupons',
      name: 'coupons',
      meta: { authRequired: true },
      component: () => import('./views/coupons/coupons')
   },

   {
      path: '/coupons/logs/:id',
      name: 'coupons.logs',
      meta: { authRequired: true },
      component: () => import('./views/coupons/logs')
   },

   {
      path: '/delivery-staffs',
      name: 'deliverystaffs',
      meta: { authRequired: true },
      component: () => import('./views/delivery-staffs/delivery-staffs')
   },

   {
      path: '/delivery-staffs/add',
      name: 'deliverystaffs.add',
      meta: { authRequired: true },
      component: () => import('./views/delivery-staffs/add-delivery-staff')
   },

   {
      path: '/delivery-staffs/edit/:id',
      name: 'deliverystaffs.edit',
      meta: { authRequired: true },
      component: () => import('./views/delivery-staffs/edit-delivery-staff')
   },

   {
      path: '/delivery-staffs/details/:id',
      name: 'deliverystaffs.details',
      meta: { authRequired: true },
      component: () => import('./views/delivery-staffs/delivery-staff-details')
   },


   {
      path: '/marketing-staffs',
      name: 'marketingstaffs',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/marketing-staffs')
   },

   {
      path: '/marketing-staffs/add',
      name: 'marketingstaffs.add',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/add-marketing-staff')
   },

   {
      path: '/marketing-staffs/edit/:id',
      name: 'marketingstaffs.edit',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/edit-marketing-staff')
   },

   {
      path: '/marketing-staffs/details/:id',
      name: 'marketingstaffs.details',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/marketing-staff-details')
   },

   {
      path: '/marketing-staffs/referrals/:id',
      name: 'marketingstaffs.referrals',
      meta: { authRequired: true },
      component: () => import('./views/marketing-staffs/referrals')
   },

   {
      path: '/clinics',
      name: 'clinics',
      meta: { authRequired: true },
      component: () => import('./views/clinics/clinics')
   },

   {
      path: '/clinics/add',
      name: 'clinics.add',
      meta: { authRequired: true },
      component: () => import('./views/clinics/add-clinic')
   },

   {
      path: '/clinics/edit/:id',
      name: 'clinics.edit',
      meta: { authRequired: true },
      component: () => import('./views/clinics/edit-clinic')
   },

   {
      path: '/clinics/details/:id',
      name: 'clinics.details',
      meta: { authRequired: true },
      component: () => import('./views/clinics/clinic-details')
   },
   {
      path: '/clinics/bookings/:id',
      name: 'clinics.bookings',
      meta: { authRequired: true },
      component: () => import('./views/clinics/bookings')
   },
   {
      path: '/clinics/doctors/:id',
      name: 'clinics.doctors',
      meta: { authRequired: true },
      component: () => import('./views/clinics/doctors')
   },

   {
      path: '/clinics/settings/:id',
      name: 'clinics.settings',
      meta: { authRequired: true },
      component: () => import('./views/clinics/settings')
   },
   {
      path: '/clinics/tv/:id',
      name: 'clinics.tv',
      meta: { authRequired: true },
      component: () => import('./views/clinics/tv')
   },

   {
      path: '/labs',
      name: 'labs',
      meta: { authRequired: true },
      component: () => import('./views/labs/labs')
   },

   {
      path: '/labs/details:id',
      name: 'labs.details',
      meta: { authRequired: true },
      component: () => import('./views/labs/lab-details')
   },

   {
      path: '/labs/add',
      name: 'labs.add',
      meta: { authRequired: true },
      component: () => import('./views/labs/add-lab')
   },

   {
      path: '/labs/edit:id',
      name: 'labs.edit',
      meta: { authRequired: true },
      component: () => import('./views/labs/edit-lab')
   },

   {
      path: '/labs/bookings:id',
      name: 'labs.bookings',
      meta: { authRequired: true },
      component: () => import('./views/labs/bookings')
   },

   {
      path: '/labs/bookings/details:id',
      name: 'labs.bookings.details',
      meta: { authRequired: true },
      component: () => import('./views/labs/booking-details')
   },
   {
      path: '/labs/schedules:id',
      name: 'labs.schedules',
      meta: { authRequired: true },
      component: () => import('./views/labs/schedule')
   },
   {
      path: '/labs/tests:id',
      name: 'labs.tests',
      meta: { authRequired: true },
      component: () => import('./views/labs/tests')
   },
   {
      path: '/tests',
      name: 'tests',
      meta: { authRequired: true },
      component: () => import('./views/labs/all-tests')
   },



   {
      path: '/tvshows',
      name: 'tvshows',
      meta: { authRequired: true },
      component: () => import('./views/tvshows/tvshows')
   },
   {
      path: '/tvshows/details:id',
      name: 'tvshows.details',
      meta: { authRequired: true },
      component: () => import('./views/tvshows/details')
   },

   {
      path: '/feedbacks',
      name: 'feedbacks',
      meta: { authRequired: true },
      component: () => import('./views/feedbacks/feedbacks')
   },
   {
      path: '/member-relations',
      name: 'member.relations',
      meta: { authRequired: true },
      component: () => import('./views/relations/relations')
   },

   {
      path: '/scroll-contents',
      name: 'scrollcontents',
      meta: { authRequired: true },
      component: () => import('./views/scrolling-contents/scrolling-contents')
   },


   {
      path: '/faqs',
      name: 'faqs',
      meta: { authRequired: true },
      component: () => import('./views/faqs/faqs')
   },

   {
      path: '/notifications',
      name: 'notifications',
      meta: { authRequired: true },
      component: () => import('./views/notifications/notifications')
   },
   {
      path: '/cms/about',
      name: 'cms.about',
      meta: { authRequired: true },
      component: () => import('./views/cms/about')
   },

   {
      path: '/cms/terms',
      name: 'cms.terms',
      meta: { authRequired: true },
      component: () => import('./views/cms/terms-and-conditions')
   },

   {
      path: '/cms/privacy-policy',
      name: 'cms.privacy',
      meta: { authRequired: true },
      component: () => import('./views/cms/privacy-policy')
   },



   {
      path: '/settings',
      name: 'settings',
      meta: { authRequired: true },
      component: () => import('./views/settings/settings')
   },

   {
      path: '/reports/consultations',
      name: 'reports.consultations',
      meta: { authRequired: true },
      component: () => import('./views/reports/consultations')
   },

   {
      path: '/reports/earnings',
      name: 'reports.earnings',
      meta: { authRequired: true },
      component: () => import('./views/reports/earnings')
   },

   {
      path: '/reports/patients',
      name: 'reports.patients',
      meta: { authRequired: true },
      component: () => import('./views/reports/patients')
   },

   {
      path: '/reports/marketing-staffs',
      name: 'reports.marketingstaffs',
      meta: { authRequired: true },
      component: () => import('./views/reports/marketing-staffs')
   },

   {
      path: '/reports/tv_show',
      name: 'reports.tv_show',
      meta: { authRequired: true },
      component: () => import('./views/reports/tv_show')
   },

   {
      path: '/reports/scrolling_contents',
      name: 'reports.scrolling_contents',
      meta: { authRequired: true },
      component: () => import('./views/reports/scrolling_contents')
   },

   {
      path: '/pincodes',
      name: 'pincodes',
      meta: { authRequired: true },
      component: () => import('./views/pincodes/pincodes')
   },

   {
      path: '/agencies',
      name: 'agencies',
      meta: { authRequired: true },
      component: () => import('./views/agency/agencies')
   },
   {
      path: '/agencies/add',
      name: 'agencies.add',
      meta: { authRequired: true },
      component: () => import('./views/agency/add-agency')
   },
   {
      path: '/agencies/edit:id',
      name: 'agencies.edit',
      meta: { authRequired: true },
      component: () => import('./views/agency/edit-agency')
   },
   // {
   //    path: '/agencies/details:id',
   //    name: 'agencies.details',
   //    meta: { authRequired: true },
   //    component: () => import('./views/labs/lab-details')
   // },

]
